import { MdOutlineFileDownload } from "react-icons/md";
import AhmedCV from "../../assets/docs/Ahmed-Ghanim-Frontend-developer.pdf";
import styles from "./About.module.css";
// import aboutImg from "../../assets/graduation-photo-1.jpg";
import aboutImg from "../../assets/personal/univirsity2.jpg";
import { SectionTitle } from "../../components/SectionTitle/SectionTitle";
import { IconLink } from "../../components/UI/IconLink/IconLink";
import { Section } from "../../layout/Section/Section";

export const About = () => {
  return (
    <Section id="about">
      <SectionTitle title="About Me" subtitle="Know more about Ahmed" />
      <div className={styles.container}>
        <img src={aboutImg} alt="Ahmed" className={styles.img} />
        <div className={styles["info-container"]}>
          <p className={styles["about-description"]}>
            🚀 Passionate front-end developer with over three years of
            experience specializing in ReactJS and React Native. Known for
            crafting captivating user experiences and delivering innovative
            solutions that exceed expectations. With a focus on user-centric
            design principles. Excellent problem solver and innovator, dedicated
            to turning ideas into reality and pushing the boundaries of what's
            possible. Ready to collaborate on projects that elevate digital
            experiences and drive results.
          </p>
          <div className={styles.info}>
            <div>
              <p className={styles["info-title"]}>15+</p>
              <span className={styles["info-name"]}>Completed Projects</span>
            </div>
            <div>
              <p className={styles["info-title"]}>100+</p>
              <span className={styles["info-name"]}>Solved Problems</span>
            </div>
          </div>
          <IconLink
            to={AhmedCV}
            text="Download Resume"
            Icon={MdOutlineFileDownload}
            isYAnimation={true}
          />
        </div>
      </div>
    </Section>
  );
};
